import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { ConfirmacaoDialog } from '../util/confirmacao.dialog';

/** AngularMaterial **/
import { MatDialogModule, MatIconModule, MatButtonModule } from '@angular/material';
/**
Lista de Componentes do MaterialDesign (importar somento o q for usar)
MaterialModule, MdAutocompleteModule, MdCheckboxModule, MdInputModule, MdRadioModule, MdSelectModule, MdSliderModule, MdSlideToggleModule, MdMenuModule, MdSidenavModule, MdToolbarModule, MdListModule, MdGridListModule, MdCardModule, MdTabsModule, MdButtonModule, MdButtonToggleModule, MdChipsModule, MdIconModule, MdProgressSpinnerModule, MdDialogModule, MdTooltipModule, MdSnackBarModule
**/

@NgModule({
    declarations: [
      ConfirmacaoDialog
    ],
    exports: [
      ConfirmacaoDialog
    ],
    imports: [
      FormsModule, CommonModule, MatIconModule, MatButtonModule,
      MatDialogModule
    ],
    entryComponents: [ConfirmacaoDialog ]

})
export class ConfirmacaoDialogModule {
}
